import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { getTestFormsList } from '../../store/selectors/authors.selector';
import { getEquipmentsWithMatSer, getFormWithDocId } from '../../store/actions/authors.action';

@Component({
    selector: 'pace-authors-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit, OnDestroy {
    private submit = new Subject<void>();
    private destroy = new Subject<void>();
    private store = inject(Store);
    private matSerialFormGroup: FormGroup;

    public homePageFormGroup: FormGroup;
    public formsList$: Observable<string[]>;
    public materialNumberControl = new FormControl();
    public serialNumberControl = new FormControl();
    // eslint-disable-next-line @typescript-eslint/unbound-method
    public documentIdControl = new FormControl('', Validators.required);

    public ngOnInit(): void {
        this.formsList$ = this.store
            .select(getTestFormsList)
            .pipe(map((formsList) => formsList.map((form) => form.FormDocid)));

        this.matSerialFormGroup = new FormGroup({
            materialNumber: this.materialNumberControl,
            serialNumber: this.serialNumberControl,
        });

        this.homePageFormGroup = new FormGroup({
            matSerialNumber: this.matSerialFormGroup,
            documentId: this.documentIdControl,
        });

        this.submit
            .asObservable()
            .pipe(
                map(() => {
                    const docId = this.documentIdControl.value;
                    const materialNumber = this.materialNumberControl.value as string;
                    const serialNumber = this.serialNumberControl.value as string;
                    if (!docId) {
                        return;
                    }
                    if (materialNumber && serialNumber) {
                        this.store.dispatch(getEquipmentsWithMatSer({ materialNumber, serialNumber, docId }));
                    } else {
                        this.store.dispatch(getFormWithDocId({ docId }));
                    }
                }),
                takeUntil(this.destroy),
            )
            .subscribe();
    }

    public ngOnDestroy(): void {
        this.destroy.next();
    }

    public submitForm(): void {
        this.submit.next();
    }
}
